import React, { lazy, Suspense } from "react";
import { useAppSelector } from "../../../store/index.ts";

const ChoseLang = lazy(() => import("./ChoseLang.jsx"));

export default function ChooseLangController() {
  const isTgBot = useAppSelector((state) => state.common.isTgBot);

  return (
    !isTgBot && (
      <Suspense>
        <ChoseLang />
      </Suspense>
    )
  );
}
